import React, { useState } from "react";
import { about } from "../data/data";
import "./About.css";

const About = () => {
  const [imgError, setImgError] = useState(false);
  return (
    <section className="about" id="about">
      <div className="about-content">
        <div className="about-photo img-container">
          {!imgError ? (
            <img
              src={about.photoPlaceholder}
              alt={about.photoAlt}
              onError={() => setImgError(true)}
            />
          ) : (
            <span className="img-placeholder">miejsce na grafikę</span>
          )}
        </div>
        <div className="about-text">
          <h2>{about.heading}</h2>
          <p>{about.description}</p>
          <a href={about.cvLink} className="about-cv-btn" download>
            {about.cvLabel}
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
